import { type JSX, type PropsWithChildren } from 'react';
import Icon, { type IconProps } from '@common/components/Icon';
import classnames from '@common/utils/ui/classnames';
import '@common/styles/components/iconMessage.pcss';

interface IconMessageProps extends PropsWithChildren<Omit<IconProps, 'size'>> {
  title: JSX.Element | string;
  wrapText?: boolean;
  'data-testid'?: string;
}

function IconMessage({
  title,
  children,
  wrapText,
  'data-testid': testId,
  ...iconProps
}: Readonly<IconMessageProps>) {
  if (children) {
    return (
      <span
        className={classnames({
          'icon-message icon-message--type-section': true,
          'icon-message--wrap-text': wrapText,
        })}
        data-testid={testId}
      >
        <span className="icon-message__header">
          <span className="icon-message__icon">
            <Icon size={24} {...iconProps} />
          </span>
          <h5>
            {title}
          </h5>
        </span>
        <span className="icon-message__content">
          {children}
        </span>
      </span>
    );
  }
  return (
    <span className="icon-message" data-testid={testId}>
      <span className="icon-message__icon">
        <Icon size={24} {...iconProps} />
      </span>
      {title}
    </span>
  );
}

export default IconMessage;
